import { useContext } from 'react';
import { AnalyticsContext, AnalyticsManager } from '../context';

export const useAnalytics = (): AnalyticsManager => {
  const context = useContext(AnalyticsContext);

  if (!context) {
    throw new Error('useAnalytics must be used within an AnalyticsProvider');
  }

  return context;
};
